import { Component } from '@angular/core';

@Component({
  selector: 'pdf-findbar-options-one-container',
  templateUrl: './pdf-findbar-options-one-container.component.html',
  styleUrls: ['./pdf-findbar-options-one-container.component.css'],
})
export class PdfFindbarOptionsOneContainerComponent {}
